var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 796.5 1301.6",
    style: {
      enableBackground: "new 0 0 796.5 1301.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000158002909613198395910000014284284675356819611_);fill:#FFF5AD;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 796.5,
    height: 1301.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161600665400471689110000002647398812843222912_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161600665400471689110000002647398812843222912_)",
      fill: "#FFF5AD"
    },
    d: "M279.7,1078 c18.7,39.2,56.4,58.8,113.1,58.8c31.4,0,56.4-5.4,75.1-16.3c18.7-10.9,33.2-25.6,43.4-44.4c10.2-18.7,16.9-40.7,19.9-66.1 c3-25.3,4.5-51.9,4.5-79.7c0-29-2.1-56.4-6.3-82.4c-4.2-25.9-12.4-49.2-24.4-69.7c-12.1-20.5-29-36.8-50.7-48.9 c-21.7-12-50.7-18.1-86.9-18.1h-86.9V541.3h85.1c27.7,0,51-5.7,69.7-17.2c18.7-11.5,33.8-26.5,45.3-45.3 c11.5-18.7,19.9-40.1,25.3-64.3c5.4-24.1,8.1-49.5,8.1-76c0-61.6-10.3-105-30.8-130.3c-20.5-25.3-51.9-38-94.1-38 c-27.8,0-50.4,5.1-67.9,15.4c-17.5,10.3-31.1,24.8-40.7,43.4c-9.7,18.7-16,40.7-19,66.1c-3,25.3-4.5,53.1-4.5,83.3h-239 c0-127.9,32-223,95.9-285.1C178,31.1,271.5,0,394.6,0c117,0,207.9,26.6,272.5,79.7C731.7,132.8,764,216,764,329.5 c0,77.2-17.2,140.3-51.6,189.2c-34.4,48.9-82.4,80-143.9,93.2v3.6c83.3,13.3,142.1,46.8,176.5,100.5c34.4,53.7,51.6,121,51.6,201.9 c0,43.4-5.4,88.1-16.3,134c-10.9,45.9-32,87.5-63.4,124.9c-31.4,37.4-74.5,67.6-129.4,90.5c-54.9,22.9-127,34.4-216.3,34.4 c-124.3,0-217.2-33.8-278.8-101.4C30.8,1132.7,0,1036.7,0,912.4V907h249.8C251,981.8,261,1038.8,279.7,1078"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo03);
export default __webpack_public_path__ + "static/media/no-03.72f8e055da23b6919aa8e71764d63e7b.svg";
export { ForwardRef as ReactComponent };